import * as React from 'react';
import { MathFunctions } from '../../global/functions/math';
import * as moment from 'moment';
import { IDropdownOption, DropdownSelect } from '../../global/components/inputs/dropdown';
import { Button } from '../../global/components/inputs/button';
import { ILiturgicalEventDto } from '../../global/DTO/liturgical-calendar';
import { Helpers } from '../../global/functions/helpers';
import DayPicker from 'react-day-picker'
import { cloneDeep } from 'lodash'

interface IProps {
    events: ILiturgicalEventDto[];
}

interface IState {
    activeDate: moment.Moment;
    hasActiveDay: boolean;
    triggerCalDayHover: boolean;
}

export class EventList extends React.Component<IProps, IState> {
    readonly ACTIVE_CLASS = "active";

    get calendarModifiers()  {
        return {
            dayWithNoEvents: this.props.events.filter(x => Helpers.IsSameDay(this.state.activeDate, moment.default(x.eventDate))).length === 0 ? this.state.activeDate.toDate() : undefined,
            lastOfTheMonth: moment.default().month() == this.earliestDate.month() && moment.default().year() && this.earliestDate.year() ? undefined : this.earliestDate.endOf('month').toDate()
        };
    }

    get earliestDate(): moment.Moment {
        return this.props.events[0].eventDateTime;
    }

    get calendarModifiedStyles() {
        return {
            dayWithNoEvents: {
                background: '#bdddef'
            },
            lastOfTheMonth: {
                background: 'white',
                color: '#e17009'
            }
        };
    }

    state: IState = {
        activeDate: moment.default(),
        hasActiveDay: false,
        triggerCalDayHover: false
    }

    render() {
        const {
            events
        } = this.props;
        const {
            activeDate,
            triggerCalDayHover,
        } = this.state;

        if (events == null || events.length < 1) {
            return null;
        }

        return (
            <div className="liturgical-calendar-events">
                <div className="mini-cal">
                    <DayPicker
                        onDayMouseEnter={(date: Date) => { this.onCalendarDayMouseEnter(moment.default(date)) }}
                        onDayMouseLeave={this.onEventDayMouseLeave}
                        month={this.earliestDate.toDate()}
                        selectedDays={triggerCalDayHover ? activeDate.toDate() : undefined}
                        canChangeMonth={false}
                        className={""}
                        modifiers={this.calendarModifiers}
                        modifiersStyles={this.calendarModifiedStyles}
                    />
                </div>
                <ul className="event-list">
                    {events.map(event => this.renderDateLineItem(event))}
                </ul>
            </div>
        );
    }

    onEventDayMouseEnter = (date: moment.Moment) => {
        this.setState({
            triggerCalDayHover: true,
            activeDate: cloneDeep(date)
        });
    }

    onEventDayMouseLeave = () => {
        this.setState({ triggerCalDayHover: false, hasActiveDay: false });
    }

    onCalendarDayMouseEnter = (date: moment.Moment) => {
        this.setState({
            hasActiveDay: true,
            activeDate: cloneDeep(date)
        });
    }

    onCalendarDayMouseLeave = () => {
        this.setState({ hasActiveDay: false });
    }


    renderDateLineItem = (event: ILiturgicalEventDto) => {
        let active =
            this.state.hasActiveDay
            && Helpers.IsSameDay(moment.default(event.eventDate), this.state.activeDate);

        return (
            <li className={(active ? this.ACTIVE_CLASS : "") + " event-item"}
                onMouseEnter={(e) => { this.onEventDayMouseEnter(moment.default(event.eventDate)) }}
                onMouseLeave={this.onEventDayMouseLeave}>
                <div className="date">{moment.default(event.eventDate).format('MMMM D')}:</div>
                <div className="event-name">{event.eventName}</div>
            </li>
        )
    }
}
